// extracted by mini-css-extract-plugin
export default {"page_layout":"PageLayout__page_layout___Sk2jR","page_layout__inner":"PageLayout__page_layout__inner___MSAzW"};